/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Sn as Sn,
} from "../../runtime/index.jsx";
export function VincularMiNumero() {
  let e = (0, ReactCompiler.c)(1),
    t;
  return (
    e[0] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((t = (
          <div
            role={`status`}
            className={`mx-auto mb-4 flex w-full max-w-xl flex-col items-start gap-2 rounded-xl border border-(--warning-border) bg-(--warning-bg) px-4 py-3 text-sm text-(--warning-texto) sm:flex-row sm:items-center sm:justify-between`}
            children={[
              <span
                children={`Tu número todavía no está vinculado: hasta que lo vincules, aquí no llega nada.`}
              />,
              <Sn
                to={`/admin/bots`}
                className={`shrink-0 font-medium underline underline-offset-2`}
                children={`Vincular mi número`}
              />,
            ]}
          />
        )),
        (e[0] = t))
      : (t = e[0]),
    t
  );
}
